// Clean the references to old TWD CDN urls.
export function cleanCDNUrls(data: any): any {
    // Only clean if the environment is not localhost and is a specific instance
    const shouldClean = window.location.hostname !== 'localhost' && ['rana'].includes(process.env.PUBLIC_INSTANCE);
    if (!shouldClean) {
        return data;
    }

    let stringData = JSON.stringify(data);

    stringData = stringData.replaceAll('twd.dev.arise-engine.com', window.location.host);
    return JSON.parse(stringData);
}
